// extracted by mini-css-extract-plugin
export default {"textCenter":"index_textCenter__iUMsY","text":"index_text__mNv6Z"};